import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import fullscreen from 'vue-fullscreen'
import VueTouchKeyboard from '@/@core/components/app-keyboard/vue-touch-keyboard/dist/vue-touch-keyboard'
import VueTouchKeyboardCustom from '@/@core/components/app-keyboard/vue-touch-keyboard-custom/dist/vue-touch-keyboard'
import VueAuthImage from 'vue-auth-image'
import VueViewer from 'v-viewer'
import router from './router'
import store from './store'
import App from './App.vue'

import './global-components'
// 3rd party plugins

import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'
// BSV Plugin Registration

Vue.use(ToastPlugin)
Vue.use(fullscreen)
Vue.use(ModalPlugin)
Vue.use(VueViewer)
Vue.use(VueTouchKeyboard)
Vue.use(VueTouchKeyboardCustom)
// register vue-auth-image directive
Vue.use(VueAuthImage)
// Global Components

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
